import "./styles.scss";

import classnames from "classnames";
import Button from "components/Button";
import Pill from "components/Pill";

const mainClass = "placeholder-page";

const PlaceholderPage = ({ title, text, button, variant, event, pill }) => {
  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--auth`]: !!variant,
      })}
    >
      <div className={`${mainClass}__wrapper`}>
        {!!pill &&
          <div className={`${mainClass}__pill`}>
            <Pill
              {...pill}
              readOnly
              size="small"
            />
          </div>
        }
        <h1>{title}</h1>
        <p>{text}</p>
        {!!Array.isArray(button) ? (
          <div className={`${mainClass}__wrapper__buttons`}>
            {button?.map(({ label, href, variant, external_href }, index) => (
              <Button key={index} size="large" href={href} variant={variant} external_href={external_href} >
                {label}
              </Button>
            ))}
          </div>
        ) : (
          !!button?.label && (
            <Button
              size="large"
              href={button?.href}
              external_href={button?.external_href}
              onClick={!!event ? event : null}
            >
              {button?.label}
            </Button>
          )
        )}
      </div>
    </div>
  );
};

export default PlaceholderPage;
